import PaymentAddressEditModal from './PaymentAddressEditModal';
import {PaymentAddress} from '../../../interfaces/payment-address';
import {useModal} from '../../../hooks/useModal';
import {Entity} from '../../../modules/auth/authorization/api';
import {QueryObserverResult, RefetchOptions, RefetchQueryFilters} from 'react-query';

interface PaymentAddressEditButtonProps {
    initialPaymentAddress: PaymentAddress;
    entity: Entity;
    refetch: <TPageData>(
        options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
    ) => Promise<QueryObserverResult<PaymentAddress>>;
}

const PaymentAddressEditButton = ({
    initialPaymentAddress,
    entity,
    refetch,
}: PaymentAddressEditButtonProps): JSX.Element => {
    const {hideModal, showModal, isDisplayed} = useModal();

    return (
        <>
            <button className="btn btn-icon btn-celeste-primary" onClick={() => showModal()}>
                <i className="bi bi-pencil-fill fs-4"></i>
            </button>
            <PaymentAddressEditModal
                initialPaymentAdress={initialPaymentAddress}
                show={isDisplayed}
                hide={hideModal}
                entity={entity}
                refetch={refetch}
            />
        </>
    );
};

export default PaymentAddressEditButton;
